'use strict';

/* globals angular */

const SetPasswordFormController = require('./SetPasswordFormController');
const SetPasswordFormDirective = require('./SetPasswordFormDirective');

const setPassword = angular.module('login.setPassword', []);

setPassword.controller('SetPasswordFormController', [
  '$rootScope',
  '$scope',
  '$stateParams',
  'sbAuth',
  SetPasswordFormController
]);

setPassword.directive('setPasswordForm', [
  SetPasswordFormDirective
]);



// WEBPACK FOOTER //
// ./src/app/login/setPasswordForm/index.js